module.exports = __webpack_public_path__ + "static/media/full-cart18.ce2d7fde.svg";